import { ReactElement, useEffect, useRef } from 'react';
import { EnergyGraphContainer, GraphContainer } from './styles';
import { useGenerateEnergyTrendsGraph } from '../../hooks/useGenerateGraph';
import { EnergyTrendsFooter } from './Footer';
import { EnergyTrendsData } from '../../types';

interface EnergyTrendsGraphProps {
  data: EnergyTrendsData | undefined;
}

export function EnergyTrendsGraph({
  data,
}: Readonly<EnergyTrendsGraphProps>): ReactElement {
  const chartReference = useRef<HTMLDivElement>(null);

  const { renderEnergyTrendsGraph } = useGenerateEnergyTrendsGraph(chartReference, !data);

  useEffect(() => renderEnergyTrendsGraph(data), [data]);

  return (
    <EnergyGraphContainer>
      <GraphContainer>
        <div id="energy-card" ref={chartReference} style={{ width: '100%', height: '100%' }} />
      </GraphContainer>
      <EnergyTrendsFooter data={data} />
    </EnergyGraphContainer>
  );
}
